module.exports = __webpack_public_path__ + "img/P150T_weapon_49.3dac7e4d.png";